var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.quarterDetails.summarize)?_c('div',{staticClass:"quarter-card"},[_c('h4',[_vm._v(_vm._s(_vm.$t('enterprise.business-review-and-outlook')))]),_c('div',{staticClass:"summary-content",domProps:{"innerHTML":_vm._s(_vm.quarterDetails.summarize)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }